import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

type FormCheckboxProps<T> = {
  inputName: string;
  label: string;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  checked?: boolean;
  style?: React.CSSProperties;
};

export function FormCheckbox<T>(props: FormCheckboxProps<T>) {
  const { inputName, label, onChange, disabled, checked, style } = props;
  const { control, trigger } = useFormContext();

  return (
    <Controller
      name={inputName}
      control={control}
      shouldUnregister={true}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              style={style}
              onChange={(e) => {
                field.onChange(e.target.checked);
                onChange && onChange(e.target.checked);
                trigger(inputName);
              }}
              checked={checked ?? field.value ?? false}
              disabled={disabled ?? undefined}
            />
          }
          label={label}
        />
      )}
    />
  );
}
